import { Controller } from "@hotwired/stimulus"
import "../platform/kit/glance/glance.js"
import { glanceFormat } from "../platform/kit/glanceFormat"

// Glance card charts outside React (docs/platform/glance_kit.md "Using it from Stimulus"):
//
//   <div data-controller="glance" data-glance-type-value="Sparkline"
//        data-glance-options-value="<%= { data: @totals, format: "inr" }.to_json %>"></div>
//
// Draws the chart at the element's width, redraws when that width or the options change
// (so a Turbo Stream that rewrites the attribute redraws it). Type "Card" draws Glance's
// metric card; its `chart` spec is drawn at the card's width and `lead` may be a spec too.
//
// Not Glance.render(): it keeps resizing with the options it was first given, so new data
// would be undone by the next resize.
//
// Report charts of a glance_* type draw through here too (story_channels/_report_chart);
// their `format` is the org's number scale as an object, which glanceFormat turns into a
// formatter.
export default class extends Controller {
  static values = { type: String, options: Object }

  connect() {
    Glance.hover(this.element)
    this.observer = new ResizeObserver(() => this.draw())
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
  }

  optionsValueChanged() {
    this.draw()
  }

  draw() {
    const type = this.typeValue
    // The capitalised functions on window.Glance are Card and the 26 charts; the rest
    // (render, hydrate, fmt…) are not something to draw.
    if (!/^[A-Z]/.test(type) || typeof Glance[type] !== "function") {
      this.element.textContent = `Unknown Glance chart “${type}”.`
      return
    }

    const width = Math.floor(this.element.clientWidth) || undefined
    const options = { width, ...this.optionsValue }
    options.format = glanceFormat(options.format)
    if (options.lead && typeof options.lead === "object") options.lead = Glance.chart(options.lead)

    const html = Glance[type](options)
    // The observer also fires when the new markup changes the height: same width, same
    // markup, nothing to do — which is also what stops a redraw loop.
    if (html === this.drawn) return
    this.element.innerHTML = this.drawn = html
    if (type === "Card") Glance.hydrate(this.element)
  }
}
